import { DEFAULT_GENERAL_OPEN_DESTINATION_OPTIONS } from '@/lib/pieveAppSettings.js';

const normalizeOpenDestinationOptions = (options) => {
  const fallbackOptions = Array.isArray(DEFAULT_GENERAL_OPEN_DESTINATION_OPTIONS) ? DEFAULT_GENERAL_OPEN_DESTINATION_OPTIONS : [];
  const source = Array.isArray(options) ? options : [];
  const dedupedOptions = [];
  const seenValues = new Set();

  for (const option of source) {
    const value = String(option?.value || option?.id || '')
      .trim()
      .toLowerCase();
    const label = String(option?.label || '').trim();
    const icon = option?.icon || null;

    if (!value || !label || seenValues.has(value)) {
      continue;
    }

    dedupedOptions.push({
      value,
      label,
      ...(icon
        ? {
            icon
          }
        : {})
    });
    seenValues.add(value);
  }

  if (!dedupedOptions.length) {
    return [...fallbackOptions];
  }

  for (const fallbackOption of fallbackOptions) {
    if (seenValues.has(fallbackOption.value)) {
      continue;
    }

    dedupedOptions.push({ ...fallbackOption });
    seenValues.add(fallbackOption.value);
  }

  const systemOptionIndex = dedupedOptions.findIndex((option) => {
    return (
      String(option?.value || '')
        .trim()
        .toLowerCase() === 'system'
    );
  });

  if (systemOptionIndex > 0) {
    const [systemOption] = dedupedOptions.splice(systemOptionIndex, 1);

    if (systemOption) {
      dedupedOptions.unshift(systemOption);
    }
  }

  return dedupedOptions;
};

export default normalizeOpenDestinationOptions;
